export default __webpack_public_path__ + "b288d9d1e0d9ce4e724e254952a44d35.png";